import repository from '@/utils/repository';

const resource = '/move/CUS_Client004';
const resource2 = '/move/MNG_Client002';

export default {
    getCustomerInfo: (data) => {
        return repository.post(`${resource}/getCustomerInfo`, {
            ...data
        });
    },
    getAreaInfo: (data) => {
        return repository.post(`move/postCommonAreaInfo`, {
            ...data
        });
    },
    getOfficeInfo: (data) => {
        return repository.post(`move/postCommonOfficeInfo`, {
            ...data
        });
    },
    store: (data) => {
        return repository.post(`${resource}/storeCustomerInfo`, {
            ...data
        });
    },
    getCustomerMFIL001: (data) => {
        return repository.post(`${resource2}/getCustomerInfo`, {
            ...data
        });
    }
};
